module.exports = __webpack_public_path__ + "fonts/Pretendard-Bold.2ac17d12.woff";